import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemMin } from 'src/app/entites/item-min';

/**
 * Affiche une unité mécanique avec image, numéro et description.
 */
@Component({
    selector: 'app-affichage-unite-item',
    templateUrl: './affichage-unite-item.component.html'
})
export class AffichageUniteItemComponent {
    @Input() item: ItemMin;
    @Input() editable: boolean = false;
    @Input() linkable: boolean = true;

    @Output() edit = new EventEmitter<void>();
}
